<div class="wrapper mb-5">
    <div class="row align-items-center m-0" style="padding: 10px;">
        <img class="p-2" src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Novo Condutor</span>
    </div>
    <div class="component-box container-fluid">
        <form class="col-12 m-0 p-0" [formGroup]="colaboradorFormGroup" #colaboradorForm="ngForm"
            (ngSubmit)="onSubmit(colaboradorFormGroup.value)">
            <div class="container-fluid pt-4">
                <div class="row">
                    <div class="col-12 text-left component-title pt-4">
                        Novo Condutor
                    </div>
                    <div class="col-12">
                        <div class="row m-0">
                            <div class="col-lg-6 col-md-6 col-sm-12 py-2 border-right">
                                <div class="row m-0">
                                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">

                                        <mat-form-field class="w-100">
                                            <mat-label class="label-required">Nome:</mat-label>
                                            <input matInput formControlName="nome" id="nome" type="text"
                                                autocomplete="off">

                                            <mat-error
                                                *ngIf="(form.nome.invalid && (form.nome.dirty || form.nome.touched)) && form.nome.errors.required">
                                                Nome é obrigatório!
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.nome.invalid && (form.nome.dirty || form.nome.touched)) && form.nome.errors.maxlength">
                                                Nome deve conter no máximo 100 caracteres.
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.nome.invalid && (form.nome.dirty || form.nome.touched)) && form.nome.errors.minlength">
                                                Nome deve conter no mínimo 3 caracteres.
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label class="label-required">Sobrenome</mat-label>
                                            <input matInput formControlName="sobrenome" id="sobrenome" type="text"
                                                autocomplete="off">

                                            <mat-error
                                                *ngIf="(form.sobrenome.invalid && (form.sobrenome.dirty || form.sobrenome.touched)) && form.sobrenome.errors.required">
                                                Sobrenome é obrigatório!
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.sobrenome.invalid && (form.sobrenome.dirty || form.sobrenome.touched)) && form.sobrenome.errors.maxlength">
                                                Sobrenome deve conter no máximo 100 caracteres.
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.sobrenome.invalid && (form.sobrenome.dirty || form.sobrenome.touched)) && form.sobrenome.errors.minlength">
                                                Sobrenome deve conter no mínimo 3 caracteres.
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label class="" [class.label-required]="documentReq">CPF
                                            </mat-label>
                                            <input matInput formControlName="documento" id="documento"
                                                [textMask]="{mask: MASKS.cpf.textMask}" [(ngModel)]="inDocumento"
                                                (blur)="CompleteWithZero()" autocomplete="off">

                                            <mat-error
                                                *ngIf="(form.documento.invalid && (form.documento.dirty || form.documento.touched)) && form.documento.errors.required">
                                                CPF é obrigatório!
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.documento.invalid && (form.documento.dirty || form.documento.touched)) && form.documento.errors.cpf">
                                                CPF é inválido!
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label class="" [class.label-required]="birthDateReq">
                                                Data de nascimento</mat-label>
                                            <input type="hidden" [ngModelOptions]="{standalone: true}"
                                                [(ngModel)]="valueBirthDate" [matDatepicker]="picker">
                                            <input matInput formControlName="dataNascimento" type="text"
                                                [textMask]="{mask: maskDate}"
                                                [ngModel]="inBirthDate | date : inBirthDate !== null?'dd/MM/yyyy' : ''"
                                                autocomplete="off"
                                                (blur)="onBlur()" (change)='todate($event.target.value, null)' />
                                            <mat-datepicker-toggle matSuffix [for]="picker">
                                            </mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>

                                            <mat-error
                                                *ngIf="(form.dataNascimento.invalid && (form.dataNascimento.dirty || form.dataNascimento.touched)) && form.dataNascimento?.errors?.required">
                                                Data de nascimento é obrigatória!
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.dataNascimento.invalid && (form.dataNascimento.dirty || form.dataNascimento.touched)) && form.dataNascimento?.errors?.minimumAge">
                                                O favorecido deve ter idade superior a {{minimumAge}} anos
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.dataNascimento.invalid && (form.dataNascimento.dirty || form.dataNascimento.touched)) && form.dataNascimento?.errors?.lockDate">
                                                Data de nascimento inválida
                                            </mat-error>
                                            <mat-error *ngIf="invalidDate">
                                                Data de nascimento inválida
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.dataNascimento.invalid && (form.dataNascimento.dirty || form.dataNascimento.touched)) && form.dataNascimento?.errors?.maximumAge">
                                                O favorecido deve ter idade inferior a {{maxAge}} anos
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label class=""
                                                [class.label-required]="cadastroColaboradorTelefoneObrigatorio">
                                                Telefone
                                                Celular</mat-label>
                                            <input matInput formControlName="celular" id="celular" type="text"
                                                [textMask]="{mask: telefoneCelularMask}" autocomplete="off">

                                            <mat-error
                                                *ngIf="(form.celular.invalid && (form.celular.dirty || form.celular.touched)) && form.celular.errors.required">
                                                Telefone celular é obrigatória!
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.celular.invalid && (form.celular.dirty || form.celular.touched)) && form.celular.errors.celular">
                                                Telefone celular inválido
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.celular.invalid && (form.celular.dirty || form.celular.touched)) && form.celular.errors.isCellPhone">
                                                Telefone celular deve conter o dígito 9
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label class="label-required">CNH</mat-label>
                                            <input matInput formControlName="cnh" id="cnh" type="text"
                                                autocomplete="off" minlength="11" maxlength="11" onlyNumber>

                                            <mat-error
                                                *ngIf="(form.cnh.invalid && (form.cnh.dirty || form.cnh.touched)) && (form.cnh.errors.maxlength || form.cnh.errors.minlength)">
                                                CNH deve conter 11 caracteres.
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label class="">
                                                Data de Validade (CNH)
                                            </mat-label>
                                            <input type="hidden" [ngModelOptions]="{standalone: true}"
                                                [(ngModel)]="valueCnhDate" [matDatepicker]="pickerCnh">
                                            <input matInput formControlName="cnhDataExpiracao" type="text"
                                                [textMask]="{mask: maskDate}"
                                                [ngModel]="inCnhDataExpiracao | date : inCnhDataExpiracao !== null?'dd/MM/yyyy' : ''"
                                                autocomplete="off"
                                                (blur)="onBlur()" (change)='todate(null, $event.target.value)' />
                                            <mat-datepicker-toggle matSuffix [for]="pickerCnh">
                                            </mat-datepicker-toggle>
                                            <mat-datepicker #pickerCnh></mat-datepicker>
                                        </mat-form-field>

                                        <!-- <div class="col-sm-12 col-md-6">
                                            <div class="input-container">
                                                <label class="label-data">Data de Validade (CNH)</label>
                                                <div class="input-group">
                                                    <input formControlName="cnhDataExpiracao"  [locale]="'pt-br'" [options]="myDatePickerOptions" angular-mydatepicker #dp="angular-mydatepicker" class="form-control m-0 input-data" name="cnhDataExpiracao" (keyup)="dateMask($event)" [maxlength]="10" autocomplete="off"/>
                                                    <button type="button" class="btn input-group-append input-group-text p-0 calendar-btn" (click)="dp.toggleCalendar()" ></button>
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">

                                        <mat-form-field class="w-100">
                                            <mat-label class="" [class.label-required]="birthDateReq">
                                                Sexo</mat-label>
                                            <mat-select formControlName="sexo" id="sexo">
                                                <mat-option disabled value="">Selecione...</mat-option>
                                                <mat-option [value]="TipoSexo.Feminino">Feminino
                                                </mat-option>
                                                <mat-option [value]="TipoSexo.Masculino">Masculino
                                                </mat-option>
                                                <mat-option [value]="TipoSexo.Indefinido">Indefinido
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label class=""
                                                [class.label-required]="cadastroColaboradorEmailObrigatorio">
                                                E-mail
                                            </mat-label>
                                            <input matInput formControlName="email" id="email" type="email"
                                                autocomplete="off">

                                            <mat-error
                                                *ngIf="(form.email.invalid && (form.email.dirty || form.email.touched)) && form.email.errors.required">
                                                E-mail é obrigatório!
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.email.invalid && (form.email.dirty || form.email.touched)) && form.email.errors.maxlength">
                                                E-mail deve conter no máximo 100 caracteres.
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.email.invalid && (form.email.dirty || form.email.touched)) && form.email.errors.email">
                                                Formato de e-mail inválido!
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label class="" [class.label-required]="motherNameReq">
                                                Nome da mãe
                                            </mat-label>
                                            <input matInput formControlName="nomeMae" id="nomeMae" type="text"
                                                autocomplete="off">

                                            <mat-error
                                                *ngIf="(form.nomeMae.invalid && (form.nomeMae.dirty || form.nomeMae.touched)) && form.nomeMae.errors.maxlength">
                                                Nome da mãe deve conter no máximo 100 caracteres.
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.nomeMae.invalid && (form.nomeMae.dirty || form.nomeMae.touched)) && form.nomeMae.errors.minlength">
                                                Nome da mãe deve conter no mínimo 3 caracteres.
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.nomeMae.invalid && (form.nomeMae.dirty || form.nomeMae.touched)) && form.nomeMae.errors.required">
                                                Nome da mãe é obrigatório!
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label class="">Nome do Pai</mat-label>
                                            <input matInput formControlName="nomePai" id="nomePai" type="text"
                                                autocomplete="off">

                                            <mat-error
                                                *ngIf="(form.nomePai.invalid && (form.nomePai.dirty || form.nomePai.touched)) && form.nomePai.errors.maxlength">
                                                Nome do pai deve conter no máximo 100 caracteres.
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.nomePai.invalid && (form.nomePai.dirty || form.nomePai.touched)) && form.nomePai.errors.minlength">
                                                Nome do pai deve conter no mínimo 3 caracteres.
                                            </mat-error>
                                        </mat-form-field>


                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6 col-sm-12 px-3">
                                <div class="accordion" id="accordionExample">
                                    <div class="card border-0">
                                        <div class="card-header bg-white mb-0" id="headingOne">
                                            <h2 class="mb-0">
                                                <button class="btn btn-block text-left panel-heading" type="button"
                                                    data-toggle="collapse" data-target="#collapseOne"
                                                    aria-expanded="true" aria-controls="collapseOne">
                                                    Informações da Empresa
                                                </button>
                                            </h2>
                                        </div>

                                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne">
                                            <div class="card-body p-2">

                                                <mat-form-field class="w-50 px-3">
                                                    <mat-label>{{ labelMatricula }}</mat-label>
                                                    <input matInput formControlName="matricula" type="text"
                                                        autocomplete="off">
                                                </mat-form-field>

                                                <mat-form-field class="w-50 px-3" *ngIf="mostrarColunaUnidade">
                                                    <mat-label class="" [class.label-required]="isUnidadeRequired">{{
                                                        labelUnidade }}</mat-label>
                                                    <mat-select formControlName="unidadeId" id="unidadeId">
                                                        <mat-option disabled value="">Selecione...
                                                        </mat-option>
                                                        <mat-option *ngFor="let itemUnidade of unidadesList"
                                                            [value]="itemUnidade.unidadeId">{{
                                                            itemUnidade.nome }}</mat-option>
                                                    </mat-select>
                                                    <mat-error
                                                        *ngIf="(form.unidadeId.invalid && (form.unidadeId.dirty || form.unidadeId.touched)) && form?.unidadeId?.errors?.required">
                                                        {{ labelUnidade }} é obrigatória!
                                                    </mat-error>
                                                </mat-form-field>

                                                <mat-form-field class="w-50 px-3" *ngIf="mostrarColunaCentroCusto">
                                                    <mat-label class="">{{ labelCentroCusto }}
                                                    </mat-label>
                                                    <mat-select formControlName="centroCustoId" id="centroCustoId">
                                                        <mat-option disabled value="">Selecione...
                                                        </mat-option>
                                                        <mat-option *ngFor="let itemCentroCusto of centrosCustosList"
                                                            [value]="itemCentroCusto.centroCustoId">{{
                                                            itemCentroCusto.nome }}</mat-option>
                                                    </mat-select>
                                                </mat-form-field>

                                                <mat-form-field class="w-50 px-3" *ngIf="mostrarColunaDepartamento">
                                                    <mat-label class="">{{ labelDepartamento }}
                                                    </mat-label>
                                                    <mat-select formControlName="departamentoId" id="departamentoId">
                                                        <mat-option disabled value="">Selecione...
                                                        </mat-option>
                                                        <mat-option *ngFor="let itemDepartamento of departamentosList"
                                                            [value]="itemDepartamento.departamentoId">{{
                                                            itemDepartamento.nome }}</mat-option>
                                                    </mat-select>
                                                </mat-form-field>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="card border-0">
                                        <div class="card-header bg-white mb-0" id="headingTwo">
                                            <h2 class="mb-0">
                                                <button class="btn  btn-block text-left collapsed" type="button"
                                                    data-toggle="collapse" data-target="#collapseTwo"
                                                    aria-expanded="false" aria-controls="collapseTwo" disabled>
                                                    Informações de Endereço
                                                </button>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo">
                                            <div class="card-body p-2">
                                                <mat-form-field class="w-50 px-3">
                                                    <mat-label [class.label-required]="addressReq">CEP</mat-label>
                                                    <input matInput formControlName="cep"
                                                        [textMask]="{mask: MASKS.cep.textMask}"
                                                        (blur)="getAddress(colaboradorFormGroup.get('cep').value)">

                                                    <mat-error
                                                        *ngIf="(form.cep.invalid && (form.cep.dirty || form.cep.touched)) && form.cep.errors.cep">
                                                        CEP inválido.
                                                    </mat-error>
                                                    <mat-error
                                                        *ngIf="(form.cep.invalid && (form.cep.dirty || form.cep.touched)) && form.cep.errors.required">
                                                        CEP é obrigatório!
                                                    </mat-error>
                                                </mat-form-field>

                                                <mat-form-field class="w-50 px-3">
                                                    <mat-label [class.label-required]="addressReq">Endereço</mat-label>
                                                    <input matInput formControlName="address">
                                                    <mat-error
                                                        *ngIf="(form.address.invalid && (form.address.dirty || form.address.touched)) && form.address.errors.required">
                                                        Endereço é obrigatório!
                                                    </mat-error>
                                                </mat-form-field>

                                                <mat-form-field class="w-50 px-3">
                                                    <mat-label [class.label-required]="addressReq">Número</mat-label>
                                                    <input onlyNumber matInput formControlName="number" maxlength="10"
                                                        (change)="semNumero(colaboradorFormGroup.get('number').value)">
                                                    <mat-error
                                                        *ngIf="(form.number.invalid && (form.number.dirty || form.number.touched)) && form.number.errors.required">
                                                        Número é obrigatório!
                                                    </mat-error>
                                                </mat-form-field>

                                                <mat-form-field class="w-50 px-3">
                                                    <mat-label>Complemento</mat-label>
                                                    <input formControlName="complement" matInput>
                                                </mat-form-field>

                                                <mat-form-field class="w-50 px-3">
                                                    <mat-label [class.label-required]="addressReq">Bairro</mat-label>
                                                    <input matInput formControlName="neighborhood">
                                                    <mat-error
                                                        *ngIf="(form.neighborhood.invalid && (form.neighborhood.dirty || form.neighborhood.touched)) && form.neighborhood.errors.required">
                                                        Bairro é obrigatório!
                                                    </mat-error>
                                                </mat-form-field>

                                                <mat-form-field class="w-50 px-3">
                                                    <mat-label [class.label-required]="addressReq">Cidade</mat-label>
                                                    <input matInput formControlName="city">
                                                    <mat-error
                                                        *ngIf="(form.city.invalid && (form.city.dirty)) && form.city.errors.required">
                                                        Cidade é obrigatório!
                                                    </mat-error>
                                                </mat-form-field>

                                                <mat-form-field class="w-50 px-3">
                                                    <mat-label [class.label-required]="addressReq">Estado</mat-label>
                                                    <input matInput formControlName="uf" maxlength="2">
                                                    <mat-error
                                                        *ngIf="(form.uf.invalid && (form.uf.dirty)) && form.uf.errors.required">
                                                        Estado é obrigatório!
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row button-container mt-5 mb-3">
                    <div class="col-12 text-right">
                        <button class="custom-button-fullbtn-back custom-button-previous"  (click)="goToBack()">
                            Voltar
                        </button>

                        <button type="submit" class="custom-button-full">
                            Cadastrar
                        </button>
                    </div>
                </div>

            </div>
        </form>
    </div>
</div>
